export default __webpack_public_path__ + "static/media/icons-02.582d39dd.svg";